import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CreateOrderModalComponent } from '../create-order-modal/create-order-modal.component';

@Component({
	selector: 'bt-selected-styles-modal',
	standalone: false,
	templateUrl: './selected-styles-modal.component.html',
	styleUrl: './selected-styles-modal.component.scss'
})
export class SelectedStylesModalComponent {
	readonly dialogRef = inject(MatDialogRef<SelectedStylesModalComponent>);
	readonly data = inject(MAT_DIALOG_DATA);

	close() {
		this.dialogRef.close();
	}
}
